import React from 'react'
import { Progress } from 'antd'

export default function DownloadProgress(props) {

    return (
        <div style={{

            display: 'flex',
            justifyContent: 'center'
        }}>
            <div style={{
                width: '60%',
                textAlign: 'center',

            }}>
                <span style={{
                    fontFamily: 'Poppins',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: 16
                }}> {props.t('DownloadAudio')}</span>

                <Progress percent={props.percent} status="active" />
            </div>
        </div>
    )
}
